// extracted by mini-css-extract-plugin
export var highlightFade = "_3e-4";
export var highlighted = "_3e-3";
export var table = "_3e-1";
export var tableContainer = "_3e-0";
export var totalsRow = "_3e-2";